module.exports = __webpack_public_path__ + "assets/images/Caixa-editorial_4699225e26892ab3e7beee1577274b76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-two/Caixa-editorial.png
// module id = 206
// module chunks = 0